/**
 * GeneralSettings Component
 * Manages sound effects toggle and reset settings inside SettingsModal
 */
import React from 'react';
import { Volume2, RotateCcw } from 'lucide-react';

export function GeneralSettings({ settings, updateSetting, resetSettings }) {
  return (
    <div className="general-settings-pane">
      <div className="general-setting-item">
        <div className="setting-info">
          <span className="setting-name">
            <Volume2 size={16} /> Âm thanh thông báo
          </span>
          <span className="setting-desc">Phát âm thanh nhẹ khi hoàn thành task hoặc thăng cấp</span>
        </div>
        <label className="switch">
          <input
            type="checkbox"
            checked={settings?.soundEffects}
            onChange={(e) => updateSetting('soundEffects', e.target.checked)}
          />
          <span className="slider round"></span>
        </label>
      </div>

      <div className="settings-divider"></div>

      <div className="general-setting-item danger-zone">
        <div className="setting-info">
          <span className="setting-name">Khôi phục cài đặt gốc</span>
          <span className="setting-desc">Đưa giao diện và hình nền về trạng thái ban đầu</span>
        </div>
        <button className="reset-settings-btn" onClick={resetSettings}>
          <RotateCcw size={14} /> Đặt lại
        </button>
      </div>
    </div>
  );
}
